import {gsap, Quart} from 'gsap/all';

class _transitions {

  constructor() {
    this.el = document.getElementById('c-cover');
    this.loader = this.el.querySelector('.c-cover__loader');
  }

  // トップページのみ実行
  loadStart() {
    gsap.to(this.loader, {
      duration: 5.0,
      x: '100%'
    });
  }

  hideOnce(callback) {
    gsap.killTweensOf(this.loader);
    gsap.to(this.loader, {
      duration: 0.6,
      x: '100%',
      ease: Quart.easeOut,
      onComplete: this.hideOnceComp.bind(this, callback),
    });
  }

  hideOnceComp(callback) {
    if (callback) callback();
    gAMBR.rootHTML.classList.add('c-cover--start');
  }

  show(done) {
    gsap.fromTo(this.el, {
      PointerEvents: 'auto',
      visibility: 'visible',
      x: '-100%',
    }, {
      duration: 0.3,
      x: '0%',
      ease: Quart.easeIn,
      onComplete: done,
    });
  }

  hide() {
    gsap.set(this.loader, {x: '100%'});
    gsap.to(this.el, {
      duration: 0.35,
      x: '100%',
      ease: Quart.easeOut,
      onComplete: this.hideComp.bind(this),
    });
  }

  hideSub() {
    gsap.set(this.loader, {x: '100%'});
    gsap.to(this.el, {
      duration: 0.5,
      x: '100%',
      ease: Quart.easeOut,
      onComplete: this.hideComp.bind(this),
    });
  }

  hideComp() {
    this.el.style.PointerEvents = 'none';
    this.el.style.visibility = 'hidden';
  }
}

const $transitions = new _transitions();

export default $transitions;